import React from 'react'
import { Icon } from 'loyal-react'
import HelpItem from './HelpItem'

export default function Recharge () {
  const faqItems =
    [
      {
        question: '1. O que é o cartão ?',
        response: 'O Cartão Pré-Pago Like+ Mastercard, pode ser utilizado em todos os estabelecimentos e ecommerce que aceitem a Mastercard'
      },
      {
        question: '2. Quais os valores dos cartãos?',
        response: 'Os valores dos cartões podem ser variados de acordo com a pontuação e opção do resgate. A calculadora fará a conversão de pontos para reais'
      },
      {
        question: '3. Onde poderei trocar o meu cartão Pré-Pago Like+?',
        response: 'Em caso de perda ou roubo é necessário entrar em contato com atendimento (11) 4020-0221 e solicitar o bloqueio do cartão e a aquisição de um novo cartão.'
      },
      {
        question: '4. Qual o prazo de entrega do cartão Pré-Pago Like+?',
        response: 'Para o recebimento do cartão com crédito o prazo são 15 dias úteis. Para a recarga do cartão até 48h o crédito estará disponível para utilizado.'
      },
      {
        question: '5. Qual a validade do cartão Pré Pago Like+?',
        response: 'O crédito tem validade de 2 anos, com cobrança de R$ 4,90 mensais a partir do 5º mês, a cobrança é efetuada somente se houver saldo no cartão.'
      },
      {
        question: '6. Qual o prazo de arrependimento do resgate do cartão Pré-Pago Like+?',
        response: 'Não há prazo de arrependimento. Não é possível cancelar o cartão.'
      },
      {
        question: '8. Qual a quantidade limite de cartões por compra?',
        response: 'Um cartão por CPF'
      },
      {
        question: '9. Há consulta de Saldo?',
        response: 'Sim. Através da Central de Atendimento (11) 4020-0221 opção 3, ou www.cartaolikemais.com.br e clique em Acesse sua conta'
      },
      {
        question: '10. Há consulta de Extrato?',
        response: 'Sim. Através do Hotsite www.cartaolikemais.com.br e clique em Acesse sua conta'
      },
      {
        question: '11. Onde posso utilizar meu cartão Pré-Pago Like',
        response: 'O cartão pode ser utilizado em toda rede de estabelecimentos e lojas virtuais que aceitam Mastercard'
      },
      {
        question: '12. Perdi meu cartão Pré-Pago Like+, como proceder?',
        response: 'Entrar em contato com a Central de Atendimento Cartão Pré-Pago Like+, opção 1 e solicitar o bloqueio do cartão. Voce também poderá solicitar um novo cartão.'
      },
      {
        question: 'Poderei utilizar o saldo restante do cartão Pré-Pago Like+ em uma nova compra?',
        response: 'Entrar em contato com a Central de Atendimento Cartão Pré-Pago Like+, opção 1 solicitar um novo cartão. Será descontado o valor de R$20,00 do seu crédito para a emissão de um novo cartão e a transferência do restante do crédito.'
      }
    ]

  return (
    <div className='position-relative'>
      <div className='col-12 p-0 flex-column mt-2'>
        <div className='row'>
          <div className='col-12 p-2 d-flex justify-content-between flex-column flex-md-row'>
            <div className='col-12 col-md-5'>
              <h2>Como podemos ajudar?</h2>
              <p className='my-2'>
                Encontre soluções e respostas sobre seu Cartão Like Mais
              </p>
            </div>
            <div className='col-12 col-md-6 form-field search-field'>
              <div className='box-search-field-desktop d-flex border-color-ui-3 border'>
                <label htmlFor='busca-likeplus-faq' className='hide-absolute'>Procurar no faq</label>
                <input
                  className='no-label no-border radius color-ui-2'
                  id='busca-likeplus-faq'
                  type='text'
                  placeholder='Ex: Como desbloquear meu cartão?'
                  name='buscar'
                  autoComplete='off'
                />
                <button
                  className={`h-100 btn-sm btn btn-flat btn-icon btn-icon-only`}
                  id='btn-search-loupe'
                >
                  <Icon
                    iconName='icon_search'
                    className='color-brand-2'
                  />
                </button>
              </div>
            </div>
          </div>
          {
            faqItems.map((item) => (
              <HelpItem {...item} />
            ))
          }
        </div>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/features/LikePlusCustom/Tabs/Help/Help.js